export default {
  common: {
    error: "Er is iets misgegaan",
    reload: "Herladen",
    errorNotification: "We zijn op de hoogte gesteld en zullen dit zo snel mogelijk oplossen. Als het probleem aanhoudt, neem dan",
    contactUs: "contact met ons op.",
    language: "Taal",
    loading: "Laden...",
    loadingText: "Laden",
    save: "Opslaan",
    savedSuccessfully: "Succesvol opgeslagen",
    saving: "Opslaan...",
    cancel: "Annuleren",
    edit: "Bewerken",
    delete: "Verwijderen",
    add: "Toevoegen",
    search: "Zoeken",
    filter: "Filter",
    clear: "Wissen",
    preview: "Voorvertoning",
    default: "Standaard: {{value}}",
    optional: "Optioneel",
    required: "Verplicht",
    noData: "Geen gegevens",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Locaties",
      cities: "Steden", 
      regions: "Regio's",
      countries: "Landen",
      showOnMap: "Toon op kaart",
      addLocation: "Locatie toevoegen"
    },
    welcome: {
      title: "Welkom bij Locations So Super.",
      subtitle: "Selecteer een sectie uit de navigatie om te beginnen."
    }
  },

  // Cities section
  cities: {
    title: "Steden",
    resourceSingular: "stad",
    resourcePlural: "steden",
    headings: {
      name: "Naam",
      status: "Status",
      locations: "Locaties", 
      region: "Regio",
      country: "Land"
    },
    breadcrumbs: {
      cities: "Steden"
    }
  },

  // Countries section  
  countries: {
    title: "Landen",
    resourceSingular: "land", 
    resourcePlural: "landen",
    headings: {
      name: "Naam",
      status: "Status",
      locations: "Locaties",
      cities: "Steden",
      regions: "Regio's"
    },
    breadcrumbs: {
      countries: "Landen"
    }
  },

  // Regions section
  regions: {
    title: "Regio's",
    resourceSingular: "regio",
    resourcePlural: "regio's", 
    headings: {
      name: "Naam",
      status: "Status",
      locations: "Locaties",
      cities: "Steden",
      country: "Land"
    },
    breadcrumbs: {
      regions: "Regio's"
    }
  },

  // Map section
  map: {
    title: "Kaart",
    breadcrumbs: {
      locations: "Locaties"
    }
  },

  // Import section
  import: {
    title: "CSV Import",
    breadcrumbs: {
      locations: "Locaties"
    },
    new: {
      title: "Importeer locaties via CSV",
      description: "Download een voorbeeld CSV-sjabloon om een voorbeeld van het vereiste formaat te zien",
      sampleTemplate: "voorbeeld CSV-sjabloon",
      uploadAndContinue: "Uploaden en doorgaan",
      abortOnError: "Afbreken bij fout",
      abortOnErrorHelp: "Als er een fout is, wordt de import afgebroken, wordt de fout weergegeven en worden er geen locaties geïmporteerd.",
      needHelp: "Hulp nodig bij het importeren van locaties?"
    },
    show: {
      title: "CSV import",
      youCanLeavePage: "U kunt deze pagina verlaten",
      backgroundMessage: "Uw import blijft op de achtergrond draaien",
      importProgress: "Importvoortgang",
      imported: "Geïmporteerd",
      suffix: "locaties",
      importLog: "Importlogboek",
      cancelImport: "Import annuleren",
      cancelConfirmation: {
        title: "Import annuleren",
        message: "Weet u zeker dat u deze importtaak wilt annuleren? Deze actie kan niet ongedaan worden gemaakt.",
        note: "Opmerking: Voor lopende taken moet de taak voltooien en wordt deze direct daarna verwijderd.",
        yesCancel: "Ja, import annuleren",
        noContinue: "Nee, import voortzetten"
      },
      report: "Rapport",
      failedLocations: "Mislukte locaties",
      uploadAnother: "Upload een andere CSV",
      backToLocations: "Terug naar locaties",
      importSucceeded: "Import geslaagd",
      importFailed: "Import mislukt"
    },
    messages: {
      uploadSuccess: "CSV succesvol geüpload",
      uploadError: "Kon CSV niet uploaden",
      pending: "Import is nog niet gestart",
      inProgress: "Import bezig",
      completed: "Import voltooid",
      invalidHeader: "De volgende kolommen zijn vereist",
      invalidCsvFile: "Ongeldig CSV-bestand",
      aborted: "Import afgebroken",
      failed: "Import mislukt",
      cancelled: "Import geannuleerd"
    },
    errors: {
      csvTooLarge: "CSV is te groot",
      languageNotEnabled: "Taal '{{language}}' is niet ingeschakeld voor deze winkel. Schakel deze eerst in bij Instellingen > Talen.",
      fieldNotTranslatable: "Veld '{{field}}' is niet vertaalbaar. Vertaalbare velden zijn: {{fields}}",
      locationError: "Locatie met slug: {{slug}} - {{error}}",
      planLimit: "U heeft uw planlimiet voor locaties bereikt"
    }
  },

  // Location form
  location: {
    index: {
      title: "Locaties",
      addLocation: "Locatie toevoegen",
      import: "Importeren",
      noPrioritySet: "Geen prioriteit ingesteld",
      published: "Gepubliceerd",
      draft: "Concept",
      resourceSingular: "locatie",
      resourcePlural: "locaties",
      headings: {
        name: "Naam",
        status: "Status", 
        city: "Stad",
        region: "Regio",
        country: "Land",
        priority: "Prioriteit"
      }
    },
    form: {
      title: "Locatie toevoegen",
      editTitle: "Locatie bewerken",
      basicInformation: "Basisinformatie",
      name: "Naam",
      namePlaceholder: "bijv. Brians Bricks",
      nameHelpDefault: "Standaard: {{defaultName}}",
      details: "Details",
      description: "Beschrijving",
      descriptionPlaceholder: "Vertel klanten wat deze locatie bijzonder maakt",
      address: "Adres",
      addressPlaceholder: "123 Hoofdstraat, Stad, Land",
      addressLine1: "Adresregel 1",
      addressLine2: "Adresregel 2",
      postalZipCode: "Postcode",
      city: "Stad",
      stateProvinceRegion: "Provincie / Regio",
      country: "Land",
      phone: "Telefoon",
      phonePlaceholder: "+31 (0)20 123 4567",
      email: "E-mail", 
      emailPlaceholder: "winkel@voorbeeld.nl",
      website: "Website",
      websitePlaceholder: "https://www.voorbeeld.nl",
      image: "Afbeelding",
      imagePlaceholder: "Voer afbeeldings-URL in",
      status: "Status",
      statusActive: "Actief",
      statusInactive: "Inactief",
      statusDraft: "Concept",
      priority: "Prioriteit",
      priorityHelpText: "Locaties met hogere prioriteit verschijnen eerst in zoekresultaten",
      findOnMapButton: "Zoek op kaart"
    },
    validation: {
      addressNotFound: "Kon adres niet vinden",
      createSuccess: "Locatie succesvol aangemaakt", 
      updateSuccess: "Locatie succesvol bijgewerkt",
      checkFields: "Controleer uw velden",
      findOnMap: "Zoek uw locatie op de kaart voordat u opslaat"
    },
    errors: {
      loading: "Fout bij het laden van locatie"
    },
    actions: {
      save: "Locatie opslaan",
      delete: "Locatie verwijderen",
      preview: "Voorvertoning"
    },
    customFields: {
      title: "Aangepaste velden",
      noCustomFields: "Geen aangepaste velden geconfigureerd",
      configureFields: "Velden configureren",
      emptyState: "U heeft nog geen aangepaste velden geconfigureerd. Aangepaste velden stellen u in staat om aanvullende informatie toe te voegen die specifiek is voor uw bedrijfsbehoeften."
    },
    openingHours: {
      title: "Openingstijden",
      checkboxLabel: "Deze locatie heeft openingstijden",
      statusOpen: "Open",
      statusOpen24h: "24 uur open",
      statusClosed: "Gesloten",
      openingTimeLabel: "Openingstijd",
      closingTimeLabel: "Sluitingstijd",
      days: {
        monday: "Maandag",
        tuesday: "Dinsdag", 
        wednesday: "Woensdag",
        thursday: "Donderdag",
        friday: "Vrijdag",
        saturday: "Zaterdag",
        sunday: "Zondag"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Onlangs toegevoegd",
        recentlyModified: "Onlangs gewijzigd"
      },
      filters: {
        status: "Status",
        taggedWith: "Gelabeld met",
        locationStatus: "Locatiestatus",
        noTagsToShow: "Geen tags om weer te geven",
        searchPlaceholder: "Zoeken"
      },
      bulkActions: {
        setPublished: "Instellen als gepubliceerd",
        setUnpublished: "Instellen als niet gepubliceerd", 
        setPriority: "Prioriteit instellen",
        deleteLocations: "Locaties verwijderen",
        exportCSV: "Exporteren als CSV"
      },
      appliedFilters: {
        statusIs: "Status is {{status}}",
        taggedWith: "Gelabeld met {{tag}}",
        nameIncludes: "Naam bevat {{search}}"
      },
      modals: {
        deleteTitle: "Locaties verwijderen",
        deleteMessage: "Weet u zeker dat u {{count}} wilt verwijderen?",
        deleteMessageAll: "Weet u zeker dat u alle locaties wilt verwijderen?",
        prioritiseTitle: "Prioriteit instellen voor {{count}} locaties",
        prioritiseTitleAll: "Prioriteit instellen voor alle locaties",
        delete: "Verwijderen",
        cancel: "Annuleren"
      },
      emptyState: {
        noResultsHeading: "Kon geen {{resourcePlural}} vinden",
        noResultsText: "Probeer de filters of zoekterm te wijzigen",
        noDataHeading: "Voeg een locatie toe om {{resourcePlural}} te vullen",
        addLocation: "Locatie toevoegen",
        importFromCSV: "Importeren vanuit CSV"
      },
      pagination: {
        label: "Pagina {{page}} van {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Succesvol bijgewerkt",
        deletedSuccessfully: "Succesvol verwijderd", 
        exportedSuccessfully: "Succesvol geëxporteerd",
        error: "Er is iets misgegaan"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Paginacontent",
    editTemplate: "SEO-sjabloon bewerken", 
    pageTitle: "Titel",
    pageDescription: "Beschrijving",
    metaTitle: "Titel",
    metaDescription: "Beschrijving",
    urlHandle: "URL-handle",
    searchEnginePreview: "Zoekmachinevermelding voorvertoning",
    editMeta: "Meta bewerken",
    previewMeta: "Meta voorvertoning",
    loading: "Laden...",
    editingLocaleHelp: "{{locale}} content bewerken."
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEO-sjablonen",
    breadcrumbs: {
      seoTemplates: "SEO-sjablonen"
    },
    template: {
      title: "{{templateName}} sjabloon - {{locale}}",
      discardChanges: "Wijzigingen negeren"
    },
    form: {
      pageContent: "Paginacontent",
      searchEnginePreview: "Zoekmachinevermelding voorvertoning",
      title: "Titel",
      description: "Beschrijving",
      pageTitle: "Paginatitel",
      metaDescription: "Meta-beschrijving",
      editingLocaleHelp: "{{locale}} vertalingen bewerken. Lege velden tonen content van {{defaultLocale}}.",
      defaultValue: "Standaard: {{value}}"
    },
    language: {
      label: "Taal",
      defaultHelp: "Dit is uw standaardtaal",
      editingHelp: "{{locale}} vertalingen bewerken. Lege velden tonen {{defaultLocale}} content."
    },
    banner: {
      multipleLanguagesDisabled: "Meerdere talen niet ingeschakeld",
      enableInSettings: "Inschakelen in Instellingen",
      multipleLanguagesInfo: "Om SEO-sjablonen voor meerdere talen te beheren, schakel internationalisering in uw taalinstellingen in. Momenteel worden alleen {{locale}} sjablonen weergegeven."
    },
    badges: {
      errors: "Fouten!",
      unsaved: "Niet opgeslagen"
    },
    messages: {
      saveSuccess: "SEO-sjablonen succesvol opgeslagen",
      saveError: "Kon sjablonen niet opslaan",
      error: "Fout..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Basisinformatie",
      name: "Naam",
      save: "Opslaan",
      saving: "Opslaan...",
      cancel: "Annuleren",
      yourLocationsIn: "Uw locaties in {{name}}",
      tableHeadings: {
        name: "Naam",
        status: "Status",
        city: "Stad",
        region: "Regio",
        country: "Land"
      },
      resourceName: {
        singular: "{{name}} locatie",
        plural: "locaties in {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Kaart",
      tags: "Tags",
      customFields: "Aangepaste velden",
      languages: "Talen",
      plan: "Plan",
      addTag: "Tag toevoegen",
      addField: "Veld toevoegen"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Eindigt binnenkort"
    },
    common: {
      loading: "Laden...",
      error: "Fout...",
      breadcrumbs: {
        settings: "Instellingen"
      },
      skeleton: {
        customFields: "Aangepaste velden",
        addField: "Veld toevoegen",
        name: "Naam",
        contentType: "Contenttype",
        usedIn: "Gebruikt in",
        field: "Veld",
        fields: "Velden"
      },
      messages: {
        savedSuccessfully: "{{setting}} instellingen succesvol opgeslagen",
        couldntSave: "Kon {{setting}} instellingen niet opslaan"
      }
    },
    map: {
      title: "Kaart",
      messages: {
        savedSuccessfully: "Kaartinstellingen succesvol opgeslagen",
        couldntSave: "Kon instellingen niet opslaan"
      },
      mapboxToken: {
        title: "Mapbox token",
        description: "Voer uw Mapbox token in om uw winkelzoeker van stroom te voorzien",
        label: "Mapbox token",
        placeholder: "Voer hier token in om uw kaart te blijven gebruiken.",
        placeholderManaged: "Voer hier token in om uw kaart te blijven gebruiken zodra u geen gratis kaartladingen meer heeft.",
        helpText: "Volg onze instructies voor het maken van een Mapbox-sleutel en plak vervolgens uw sleutel hierboven. Als u problemen ondervindt, neem dan contact met ons op voor hulp.",
        linkInstructions: "instructies voor het maken van een Mapbox-sleutel",
        linkSupport: "neem contact met ons op voor hulp"
      },
      managedToken: {
        title: "Kaartladingen",
        description: "U heeft tot {{max}} gratis kaartladingen met een beheerd token, daarna moet u uw eigen token maken."
      },
      appearance: {
        title: "Uiterlijk",
        description: "Wijzig de visuele weergave van uw kaart"
      },
      mapStyle: {
        title: "Kaartstijl",
        options: {
          streets: "Straten",
          outdoors: "Buiten", 
          light: "Licht",
          dark: "Donker",
          satellite: "Satelliet",
          satelliteStreets: "Satellietstraten",
          navigationDay: "Navigatie Dag",
          navigationNight: "Navigatie Nacht"
        }
      },
      searchBehaviour: {
        title: "Zoekgedrag",
        description: "Bepaalt hoe bezoekers locaties op uw kaart vinden.",
        geolocateLabel: "Schat automatisch de locatie van de bezoeker en toon nabijgelegen winkels",
        geolocateHelp: "Als geolocatie slaagt, verplaatst de kaart zich om zich te concentreren nabij de bezoeker. Als een geschatte locatie niet kan worden gevonden, blijft de kaart op de startpositie.",
        filterBehaviour: {
          title: "Filtergedrag",
          all: {
            label: "Alle tags",
            help: "Om een locatie in filters te laten verschijnen, moet deze alle geselecteerde tags hebben"
          },
          any: {
            label: "Elke tag", 
            help: "Om een locatie in filters te laten verschijnen, kan deze een van de geselecteerde tags hebben"
          }
        },
        keepSearchInView: {
          label: "Zoekmarkering in beeld houden",
          help: "Wanneer zoekresultaten verschijnen, zoomt de kaart uit om alle overeenkomende locaties te tonen"
        },
        distanceUnits: {
          title: "Afstandseenheden",
          km: "Kilometers",
          miles: "Mijlen"
        },
        maxResults: {
          label: "Max resultaten",
          help: "Beperk het aantal locaties dat in zoekresultaten wordt getoond",
          options: {
            results30: "30 resultaten"
          }
        },
        maxDistance: {
          label: "Max afstand", 
          help: "Toon alleen locaties binnen deze afstand van het zoekpunt",
          options: {
            unlimited: "Onbeperkt"
          }
        },
        showLocationNames: {
          label: "Toon locatienamen in suggesties",
          help: "Toon locatienamen in zoeksuggesties"
        },
        sortByPriority: {
          label: "Sorteer op prioriteit in plaats van afstand",
          help: "Het wordt ten zeerste aanbevolen om een maximale afstand in te stellen (die niet Onbeperkt is) als dit vakje is aangevinkt. Anders zien uw klanten verre locaties met een hoge prioriteit vermeld boven die binnen een redelijke afstand van hen (of hun zoekopdracht, meer specifiek)."
        }
      },
      searchResults: {
        title: "Zoekresultaten",
        description: "Bepaalt hoe locaties op uw kaart worden geretourneerd.",
        locationsLabel: "Zoekresultatentekst",
        locationsHelp: "Tekst getoond boven zoekresultaten (bijv. '5 locaties weergeven')",
        prefixLabel: "Zoekresultatenvoorvoegsel", 
        prefixHelp: "Tekst getoond vóór het aantal resultaten"
      },
      popups: {
        title: "Pop-ups",
        showPopups: {
          label: "Pop-ups tonen",
          help: "Toon locatiedetails wanneer bezoekers op kaartmarkeringen klikken"
        }
             },
       whitelabel: {
         title: "Whitelabel",
         hideLabel: "Verberg 'powered by' tekst",
         hideHelp: "Verwijder onze branding van uw winkelzoeker"
       }
    },
    languages: {
      title: "Talen",
      error: "Fout...",
      messages: {
        savedSuccessfully: "Taalinstellingen succesvol opgeslagen",
        couldntSave: "Kon taalinstellingen niet opslaan"
      },
      banner: {
        upgradeTitle: "Meertalige ondersteuning vereist planupgrade",
        upgradeAction: "Upgrade naar Superest",
        upgradeMessage: "U kunt nog steeds uw standaardtaal wijzigen, maar het inschakelen van meerdere talen vereist een upgrade.",
        disabledMessage: "Meertalige instellingen zijn uitgeschakeld op uw huidige plan"
      },
      defaultLanguage: {
        title: "Standaardtaal", 
        description: "Kies uw primaire taal waarin uw content wordt weergegeven.",
        label: "Standaardtaal",
        help: "Deze taal wordt gebruikt wanneer geen specifieke taal wordt aangevraagd"
      },
      internationalization: {
        title: "Internationalisering",
        description: "Schakel meerdere talen in. Bereik meer klanten en verhoog uw SEO.",
        enableLabel: "Meerdere talen inschakelen",
        enableHelp: "Sta klanten toe om uw winkelzoeker in verschillende talen te bekijken"
      },
      supportedLanguages: {
        title: "Aanvullende ondersteunde talen",
        description: "Selecteer aanvullende talen die u wilt ondersteunen. Zodra u een taal heeft ingeschakeld, ziet u de optie om vertalingen te verstrekken door de hele app. Voor ondersteunde talen worden de standaard SEO-sjablonen, evenals de gemeenschappelijke variabele thema's automatisch gegenereerd.",
        defaultLocaleNote: "Dit is uw standaardtaal en kan niet worden uitgeschakeld",
        shopifyEnabled: {
          label: "Deze taal is ingeschakeld in mijn Shopify-winkel",
          importantNote: "Belangrijk:",
          description: "Vink het bovenstaande vakje uit als deze taal niet is ingeschakeld en gepubliceerd voor uw Shopify-winkel. Het wordt aanbevolen om de taal eerst in te schakelen voor uw Shopify-winkel door naar Instellingen > Talen te gaan in uw Shopify-beheer als u dat nog niet heeft gedaan voor een soepelere klantervaring."
        },
        urlFormats: {
          cleanUrls: "Schone URL's:",
          betterSeo: "Betere SEO en gebruikerservaring",
          queryUrls: "Query-parameter URL's:",
          considerEnabling: "Overweeg in te schakelen in Shopify voor betere URL's"
        },
        preview: {
          button: "Voorvertoning",
          tooltip: "Voorvertoning {{language}} winkelzoeker"
        },
        tooltips: {
          noTemplates: "Geen standaard SEO-sjablonen beschikbaar voor deze taal. U kunt eenvoudig aangepaste vertalingen maken."
        }
      }
    },
    tags: {
      title: "Tags",
      addTag: "Tag toevoegen",
      error: "Fout",
      messages: {
        deletedSuccessfully: "Tags succesvol verwijderd",
        couldntDelete: "Tags konden niet worden verwijderd",
        savedSuccessfully: "Tag succesvol opgeslagen",
        couldntSave: "Controleer uw velden",
        tagDeleted: "Tag succesvol verwijderd"
      },
      resourceName: {
        singular: "tag",
        plural: "tags"
      },
      filters: {
        anyGroup: "Elke groep",
        inGroup: "In groep",
        tagGroup: "Tag groep"
      },
      appliedFilters: {
        inGroup: "In {{group}} groep",
        nameContains: "Tagnaam bevat {{query}}"
      },
      bulkActions: {
        deleteTag: "Tag verwijderen",
        deleteTags: "Tags verwijderen"
      },
      form: {
        language: "Taal",
        title: "Titel",
        description: "Beschrijving",
        group: "Groep",
        groupPlaceholder: "Selecteer groep",
        addGroup: "Toevoegen",
        editingTranslations: "{{language}} vertalingen bewerken. Lege velden tonen content van {{defaultLanguage}}.",
        defaultValue: "Standaard: {{value}}",
        image: "Afbeelding",
        imageUrl: "Afbeeldings-URL"
      },
      actions: {
        save: "Opslaan",
        deleteTag: "Tag verwijderen"
      },
      new: {
        title: "Tag toevoegen",
        messages: {
          createSuccess: "Tag succesvol aangemaakt",
          checkFields: "Controleer uw velden"
        },
        actions: {
          createTag: "Tag aanmaken"
        }
      }
    },
    customFields: {
      title: "Aangepaste velden",
      addField: "Veld toevoegen",
      error: "Fout",
      resourceName: {
        singular: "Veld",
        plural: "Velden"
      },
      headings: {
        name: "Naam",
        contentType: "Contenttype",
        usedIn: "Gebruikt in"
      },
      emptyState: {
        heading: "Maak en beheer uw aangepaste velden",
        createAction: "Veld aanmaken",
        description: "Gebruik aangepaste velden voor unieke attributen over uw locaties. Deze velden kunnen van alles zijn, van sociale profielen tot de naam en e-mail van de winkelmanager"
      },
      pluralization: {
        location: "locatie",
        locations: "locaties"
      },
      form: {
        name: "Naam",
        contentType: "Contenttype",
        key: "Sleutel",
        keyPrefix: "location.fields.",
        keyHelp: "Gebruik deze sleutel om toegang te krijgen tot de {{name}} content van een locatie in uw liquid-sjablonen.",
        translations: {
          title: "Vertalingen",
          showTranslations: "Vertalingen tonen",
          hideTranslations: "Vertalingen verbergen",
          description: "Vertalingen zijn optioneel. Lege velden tonen de {{language}} veldnaam.",
          nameTranslation: "Naam ({{language}})",
          defaultValue: "Standaard: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Veld succesvol opgeslagen",
        couldntSave: "Veld kon niet worden opgeslagen",
        deletedSuccessfully: "Veld succesvol verwijderd",
        couldntDelete: "Veld kon niet worden verwijderd"
      },
      actions: {
        delete: "Verwijderen"
      },
      new: {
        title: "Veld toevoegen",
        messages: {
          savedSuccessfully: "Veld succesvol opgeslagen",
          couldntSave: "Veld kon niet worden opgeslagen"
        }
      },
      contentTypes: {
        text: "Tekst",
        textArea: "Tekstgebied", 
        email: "E-mail",
        number: "Nummer",
        phoneNumber: "Telefoonnummer",
        time: "Tijd",
        url: "URL"
      }
    },
    plan: {
      title: "Plan",
      error: "Fout",
      changePlan: "Plan wijzigen",
      usdPerMonth: "USD / maand",
      sections: {
        yourPlanIncludes: "Uw plan omvat",
        nextBillingDate: "Volgende factuurdatum",
        trial: "Proefperiode"
      },
      banners: {
        planUpdated: "Uw plan is bijgewerkt",
        thankYouUpgrading: "Bedankt voor het upgraden!",
        letUsKnow: "Laat het ons weten",
        improvementText: "als er iets is dat we beter kunnen doen.",
        trialCancellation: {
          title: "Kennisgeving proefperiode annulering",
          message: "Uw 14-daagse gratis proefperiode wordt geannuleerd zodra u upgradet naar een betaald abonnement."
        }
      },
      locations: {
        upTo: "Tot",
        locations: "locaties",
        unlimited: "Onbeperkt aantal locaties",
        used: "gebruikt",
        ofUsed: "{{used}} van {{max}} gebruikt"
      },
      trial: {
        daysLeft: "{{days}} dagen over",
        daysUsed: "{{used}} van {{total}} dagen gebruikt",
        selectPlan: "Selecteer een plan",
        currentPlan: "Huidig plan",
        trialBadge: "Proefperiode",
        currentBadge: "Huidig",
        yourTrialJustStarted: "Uw proefperiode is net begonnen",
        trialEndsAfterToday: "Uw proefperiode eindigt na vandaag",
        trialEndsTomorrow: "Uw proefperiode eindigt morgen",
        daysLeftInTrial: "{{days}} dagen over in uw proefperiode",
        continueAddingLocations: "Blijf locaties toevoegen na {{date}} door een plan te selecteren",
        selectPlanToday: "Selecteer vandaag een plan om door te gaan met het toevoegen van locaties"
      },
      footer: {
        description: "Beheer of wijzig uw Locations So Super plan. Bekijk onze",
        termsOfService: "servicevoorwaarden",
        and: "en",
        privacyPolicy: "privacybeleid"
      },
      features: {
        analytics: {
          title: "Analyses",
          description: "Ontdek hoe mensen uw locaties gebruiken en waar ze naar zoeken"
        },
        internationalization: {
          title: "Meertalige ondersteuning",
          description: "Verhoog SEO en bereik meer klanten in doelmarkten door meerdere talen in te schakelen"
        },
        customThemes: {
          editLiquid: {
            title: "Bewerk thema liquid-sjablonen",
            description: "Toon locatiegegevens op elke gewenste manier met toegang tot thema liquid"
          },
          editStructuredData: {
            title: "Bewerk bedrijfsgestructureerde gegevens",
            description: "Bewerk hoe Google pagina's begrijpt door uw gestructureerde gegevens te bewerken"
          }
        }
      },
      edit: {
        title: "Plan wijzigen",
        allPlansInclude: "Alle bovenstaande plannen omvatten",
        needingMoreLocations: "Meer locaties nodig?",
        footerQuestion: "Heeft u vragen voordat u begint?",
        sendMessage: "stuur ons een bericht",
        allFeatures: {
          seoDirectory: {
            title: "SEO-directory en landingspagina's",
            description: "Maak automatisch een SEO-directory van al uw locaties, steden en regio's"
          },
          mapPage: {
            title: "Kaartpagina met zoeken en filter",
            description: "Zoek en filter al uw locaties op een kaart aangedreven door mapbox"
          },
          tags: {
            title: "Tags",
            description: "Maak tags met afbeeldingen en beschrijvingen en groepeer ze"
          },
          openingHours: {
            title: "Openingstijden",
            description: "Stel openingstijden in en toon ze voor uw locaties"
          },
          mapStyles: {
            title: "Kaartstijlen",
            description: "Wijzig het uiterlijk van de kaarten met een aantal vooraf ingestelde stijlen"
          },
          customFields: {
            title: "Aangepaste velden",
            description: "Voeg nieuwe velden toe die u wilt, van sociale links tot winkelmanager"
          },
          csvUpload: {
            title: "Uploaden en exporteren met CSV",
            description: "Upload en bewerk uw locaties in bulk."
          },
          richSnippets: {
            title: "Rijke snippets",
            description: "Help Google pagina's beter te begrijpen met gestructureerde gegevens voor lokale bedrijven"
          },
          directionsAndCalls: {
            title: "Routebeschrijving en oproepen",
            description: "Bezoekers kunnen eenvoudig routebeschrijving krijgen en bellen naar de locaties"
          },
          languageSupport: {
            title: "Taalondersteuning",
            description: "Wijzig de standaardtaal naar iets anders dan Engels. Vertaalsjablonen beschikbaar voor 32 belangrijke talen voor eenvoudige installatie."
          }
        }
      },
      planCard: {
        bestToCustomize: "Beste om aan te passen",
        currentPlan: "Huidig plan",
        chooseThisPlan: "Kies dit plan",
        locationsSection: "Locaties",
        featuresSection: "Functies",
        upTo: "Tot",
        locations: "locaties",
        tooltipTooManyLocations: "U heeft te veel locaties en/of ingeschakelde talen voor dit plan."
      },
      confirmation: {
        error: "Fout bij bevestigen van plan"
      }
    }
  },

  // Themes section
  themes: {
    title: "Thema's",
    currentTheme: {
      title: "Huidig thema",
      description: "Dit is het thema dat klanten zien wanneer ze uw locatie-app bezoeken."
    },
    themeLibrary: {
      title: "Themabibliotheek", 
      description: "Beheer uw locatielocatie-thema's. Voeg thema's toe en publiceer ze om het uiterlijk van uw online locatie te wijzigen."
    },
    skeleton: {
      currentThemeDescription: "Dit is het thema dat uw klanten zien wanneer ze uw locatie-app gebruiken."
    },
    modal: {
      overrideTitle: "Huidig thema overschrijven?",
      override: "Overschrijven",
      cancel: "Annuleren",
      undoWarning: "Deze actie kan niet ongedaan worden gemaakt."
    },
    messages: {
      publishSuccess: "Thema succesvol gepubliceerd",
      publishError: "Kon thema niet publiceren",
      error: "Er is iets misgegaan"
    },
    emptyStates: {
      settings: {
        heading: "Dit thema heeft geen instellingen",
        description: "Maak instellingen in de sjablooneditor.",
        createSettings: "Instellingen aanmaken",
        upgradePlan: "Plan upgraden",
        upgradeRequired: "Plan upgraden om instellingen aan te maken"
      },
      language: {
        heading: "Dit thema heeft geen taaltermen",
        description: "Maak taaltermen in de sjablooneditor.",
        createLanguageTerms: "Taaltermen aanmaken",
        upgradePlan: "Plan upgraden",
        upgradeRequired: "Plan upgraden om taaltermen aan te maken"
      }
    },
    templates: {
      categories: {
        templates: "Sjablonen",
        schemas: "Schema's",
        styles: "Stijlen",
        liquidReference: "Liquid referentie"
      },
      items: {
        landing: "Landing",
        directory: "Directory",
        country: "Land",
        region: "Regio",
        city: "Stad",
        location: "Locatie",
        language: "Taal",
        settings: "Instellingen",
        stylesheet: "Stylesheet"
      },
      errors: {
        errorsInTemplate: "Fouten in sjabloon",
        error: "Fout"
      },
      badges: {
        errors: "Fouten!",
        unsaved: "Niet opgeslagen"
      },
      actions: {
        viewTheme: "Thema bekijken",
        discard: "Negeren",
        save: "Opslaan"
      }
    },
    language: {
      messages: {
        saveSuccess: "Thema taalvertalingen succesvol opgeslagen",
        saveError: "Thema kon niet worden opgeslagen"
      },
      form: {
        language: "Taal",
        defaultLanguageHelp: "Dit is uw standaardtaal",
        translationHelp: "Vertalingen bewerken voor {{selectedLocale}}. Lege velden tonen content van {{defaultLocale}} (uw standaardtaal)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Meerdere talen niet ingeschakeld",
          action: "Inschakelen in Instellingen",
          description: "Om vertalingen voor meerdere talen te beheren, schakel internationalisering in uw taalinstellingen in. Momenteel worden alleen {{locale}} vertalingen weergegeven."
        },
        translating: {
          title: "{{to}} vertalingen bewerken",
          description: "Elk veld dat u leeg laat, toont automatisch de {{defaultLocale}} content aan uw klanten. Vertaal alleen de velden waar u verschillende content wilt in {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Toegang tot de {{category}} taaltermen in liquid met {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Titel",
        description: "Beschrijving",
        heading: "Kop",
        subheading: "Ondertitel",
        button_text: "Knoptekst",
        link_text: "Linktekst",
        placeholder: "Placeholder",
        label: "Label",
        help_text: "Helptekst",
        error_message: "Foutmelding",
        success_message: "Succesmelding",
        
        // Opening hours
        Monday: "Maandag",
        Tuesday: "Dinsdag",
        Wednesday: "Woensdag",
        Thursday: "Donderdag",
        Friday: "Vrijdag",
        Saturday: "Zaterdag",
        Sunday: "Zondag",
        opening_hours_format: "Openingstijden formaat",
        closes_at_format: "Sluit om formaat",
        opens_at_format: "Opent om formaat",
        opens_on: "Opent op",
        open_24h: "24 uur open",
        open: "Open",
        closed: "Gesloten",
        closes_at: "Sluit om",
        opens_at: "Opent om",
        
        // Map
        search_map: "Zoek op kaart",
        search_area: "Zoek in dit gebied",
        view_map: "Kaart",
        view_list: "Lijst",
        open_filters: "Filters",
        stores_near_you: "Winkels bij u in de buurt",
        header: "Vind een winkel!",
        search_placeholder: "Typ een postcode of adres...",
        no_listings: "Sorry, we kunnen geen locaties vinden voor uw zoekopdracht. Probeer de filters of de zoeklocatie te wijzigen",
        
        // Directory
        view_directory: "Winkeldirectory",
        
        // Location
        get_directions: "Routebeschrijving",
        call: "Bellen",
        view_website: "Website",
        email: "E-mail",
        opening_hours_header: "Openingstijden",
        description_header: "Informatie",
        phone_number_header: "Telefoon",
        address_header: "Adres",
        tag_groups_to_display: "Tag groepen om weer te geven"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Algemeen",
        navigation: "Navigatie",
        forms: "Formulieren",
        buttons: "Knoppen",
        messages: "Berichten",
        errors: "Fouten",
        opening_hours: "Openingstijden",
        map: "Kaart",
        directory: "Directory",
        location: "Locatie"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Thema succesvol opgeslagen",
        saveError: "Thema kon niet worden opgeslagen"
      },
      accessSettings: "Toegang tot de {{category}} instellingen in liquid met {{code}}",
      fields: {
        // Colors
        color_text: "Tekstkleur",
        color_text_heading: "Koptekstkleur", 
        color_background: "Achtergrondkleur",
        color_accent: "Accentkleur",
        color_text_positive: "Positieve tekstkleur",
        color_text_negative: "Negatieve tekstkleur",
        dark_theme: "Donker thema",
        color_marker: "Markeerkleur",
        color_search_marker: "Zoekmarkeerkleur",
        
        // Typography
        base_font_size: "Basislettergrootte",
        
        // Buttons
        border_radius: "Randradius",
        
        // Images
        aspect_ratio: "Beeldverhouding",
        fit: "Passen",
        
        // Spacing
        page_width: "Paginabreedte",
        page_width_small: "Paginabreedte klein",
        gutter_desktop: "Goot desktop",
        gutter_mobile: "Goot mobiel",
        desktop_vertical_spacing: "Verticale ruimte desktop",
        mobile_vertical_spacing: "Verticale ruimte mobiel",
        
        // Breakpoints
        breakpoint_xs: "Breekpunt XS",
        breakpoint_sm: "Breekpunt SM",
        breakpoint_md: "Breekpunt MD",
        
        // Map
        search_on_move: "Zoeken bij verplaatsen",
        scroll_to_zoom: "Scrollen om in te zoomen",
        
        // Landing page
        sidebar_width: "Zijbalkbreedte",
        sidebar_min_height: "Zijbalk minimale hoogte",
        marker_image_src: "Markeerafbeelding bron",
        show_filter_descriptions: "Filterbeschrijvingen tonen",
        
        // Location page
        tag_groups_to_display: "Tag groepen om weer te geven",
        tag_groups_to_display_as_icons: "Tag groepen om weer te geven als pictogrammen",
        show_related_locations: "Gerelateerde locaties tonen",
        
        // Locations
        hide_regions: "Regio's verbergen"
      },
      categories: {
        colors: "Kleuren",
        typography: "Typografie",
        buttons: "Knoppen",
        images: "Afbeeldingen",
        spacing: "Ruimte",
        breakpoints: "Breekpunten",
        map: "Kaart",
        landing_page: "Landingspagina",
        location_page: "Locatiepagina",
        locations: "Locaties"
      }
    },
    navigation: {
      sublimeTheme: "Sublime Thema",
      settings: "Instellingen",
      language: "Taal",
      templates: "Sjablonen",
      changeTheme: "Thema wijzigen",
      viewDirectory: "Directory bekijken",
      viewLandingPage: "Landingspagina bekijken"
    },
    card: {
      lastUpdated: "Laatst bijgewerkt",
      view: "Bekijken",
      customize: "Aanpassen",
      publish: "Publiceren",
      actions: "Acties"
    }
  },

  // Analytics section
  analytics: {
    title: "Analyses",
    timePeriods: {
      last7days: "Laatste 7 dagen",
      last30days: "Laatste 30 dagen"
    },
    comparison: {
      compareToPrevious: "Vergelijken met vorige periode",
      stopComparing: "Stoppen met vergelijken met vorige periode"
    },
    sections: {
      searchLocations: "Zoeklocaties"
    },
    cards: {
      sessions: "Sessies",
      topSearches: "Top zoekopdrachten",
      topLandingPageType: "Top landingspaginatype",
      topPageViewsBySession: "Top paginaweergaven per sessie",
      topLocations: "Top locaties",
      topReferrers: "Top verwijzers",
      searches: "Zoekopdrachten",
      topLandingPagesBySession: "Top landingspagina's per sessie"
    },
    chartLabels: {
      desktop: "Desktop"
    }
  },

};
